import { render, staticRenderFns } from "./OrgProfilePage.vue?vue&type=template&id=68cefac4&scoped=true&"
import script from "./OrgProfilePage.vue?vue&type=script&lang=js&"
export * from "./OrgProfilePage.vue?vue&type=script&lang=js&"
import style0 from "./OrgProfilePage.vue?vue&type=style&index=0&id=68cefac4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cefac4",
  null
  
)

export default component.exports